import type { ChatLike, ChatOptions, ChatResponse, ToolCall } from './llm';

/**
 * Deterministic test/dev double for an ai.libx.js AIClient. Plays a scripted
 * queue of ChatResponses (tool_calls then a final answer). Records each
 * ChatOptions it saw so tests can assert tools were advertised and tool
 * results were threaded back. No network, no API key.
 */
export class FakeAIClient implements ChatLike {
  public seen: ChatOptions[] = [];
  private script: ChatResponse[];

  constructor(script: ChatResponse[]) {
    this.script = [...script];
  }

  async chat(options: ChatOptions): Promise<ChatResponse> {
    this.seen.push(options);
    const next = this.script.shift();
    if (!next) throw new Error('FakeAIClient: script exhausted (model asked for more turns than scripted)');
    return next;
  }
}

/** Build a tool_call block (arguments JSON-stringified, matching the wire format). */
export const toolCall = (id: string, name: string, args: object): ToolCall => ({
  id,
  type: 'function',
  function: { name, arguments: JSON.stringify(args) },
});
